"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function snakeToCamelCase(keyName) {
    var _a = keyName.split('_'), first = _a[0], others = _a.slice(1);
    return [first].concat(others.map(capitalize)).join('');
}
exports.snakeToCamelCase = snakeToCamelCase;
//# sourceMappingURL=stringUtils.js.map


// WEBPACK FOOTER //
// ../../src/utils/stringUtils.ts